import React from "react"
import { css } from "@emotion/core"

import * as mixins from "../../../utils/mixins"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { revegetationPageMetadata } from "../../../utils/seo"

import RevegetationImageTwo from "../../components/imageComponents/revegetation/RevegetationTwo"

import TopDisplayImageCont from "../../components/imageComponents/TopDisplayImageCont"
import TopImage from "../../components/imageComponents/optimized/inspections"
import { InspectionsTopImageTitle } from "../../components/layoutComponents/top-image-title"

import * as TextComponent from "../../components/textComponents"
import * as LayoutComponent from "../../components/layoutComponents"
import * as InteractiveComponent from "../../components/interactiveComponents"

import {
  HeaderNavBar,
  HeaderNavBarBackLink,
} from "../../components/layoutComponents/header-nav-bar"

function InspectionsPage() {
  return (
    <Layout>
      <SEO
        title="Revegetation"
        description="Guaranteed growth of lawns, trees and Shrubbery in the Marin County area. Ponderosa Ventures Ltd."
        meta={revegetationPageMetadata}
      />
      <HeaderNavBar>
        <HeaderNavBarBackLink to="/">BACK TO SERVICES</HeaderNavBarBackLink>
      </HeaderNavBar>
      <TopDisplayImageCont>
        <InspectionsTopImageTitle />
        <TopImage />
      </TopDisplayImageCont>
      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText>
          Guaranteed results. The success of your lawn, newly-planted trees, or
          shrubbery is a sure thing when you rely on Ponderosa.
        </TextComponent.BodyText>

        <TextComponent.BodyText>
          We select the seeds/plants, plant them with the right soils and
          nutrients and provide the initial care.
        </TextComponent.BodyText>
      </LayoutComponent.SectionContainer>

      <LayoutComponent.SectionTitleBanner>
        WHAT WE PLANT
      </LayoutComponent.SectionTitleBanner>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText
          styles={css`
            margin-bottom: 1rem;

            ${mixins.device.mobileX} {
              margin-top: 0.25rem;
              margin-bottom: 1.15rem;
            }
          `}
        >
          Here&apos;s what we can specialize in:
        </TextComponent.BodyText>

        <TextComponent.TreeListItem>
          Lawns and grass seeds
        </TextComponent.TreeListItem>
        <TextComponent.TreeListItem>
          Trees (including pine, aspen, and oak)
        </TextComponent.TreeListItem>
        <TextComponent.TreeListItem>
          Drought resistant shrubbery
        </TextComponent.TreeListItem>
      </LayoutComponent.SectionContainer>

      <div
        css={css`
          width: 100%;
          max-height: 12rem;

          ${mixins.device.mobileL} {
            max-height: 16rem;
          }

          ${mixins.device.tablet} {
            max-height: 20rem;
          }
        `}
      >
        <RevegetationImageTwo />
      </div>

      <LayoutComponent.SectionContainer>
        <TextComponent.BodyText>
          <TextComponent.BodyBold>Have questions?</TextComponent.BodyBold> Get
          in touch, we’d love to find out how we can save you time and money on
          your project.
        </TextComponent.BodyText>

        <InteractiveComponent.Button to="/contact-us/">
          CONTACT US
        </InteractiveComponent.Button>
      </LayoutComponent.SectionContainer>
    </Layout>
  )
}

export default InspectionsPage
